/**
 * Large Image Block — optional scroll-linked scale or parallax
 */

import { isBlockOnPage } from "../../src/js/modules/block-present.js";

(function () {
  "use strict";

  if (!isBlockOnPage("large-image")) {
    return;
  }

  function initLargeImageEffects() {
    document
      .querySelectorAll(".large-image.large-image--scale-animation")
      .forEach((block) => initScaleAnimation(block));

    document
      .querySelectorAll(".large-image.large-image--parallax")
      .forEach((block) => initParallaxAnimation(block));
  }

  function canAnimate() {
    return (
      typeof window.gsap !== "undefined" &&
      typeof window.ScrollTrigger !== "undefined"
    );
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  /**
   * Scale media from 90% → 100% (centred) on scroll.
   */
  function initScaleAnimation(block) {
    const media = block.querySelector(".large-image__media");
    if (!media || !canAnimate()) return;

    if (prefersReducedMotion()) {
      window.gsap.set(media, { scale: 1, transformOrigin: "50% 50%" });
      return;
    }

    window.gsap.set(media, { transformOrigin: "50% 50%" });

    window.gsap.fromTo(
      media,
      { scale: 0.9 },
      {
        scale: 1,
        ease: "expoScale(0.5,7,none)",
        scrollTrigger: {
          trigger: block,
          start: "-65% top",
          end: "+=40%",
          scrub: 0.2,
          invalidateOnRefresh: true,
          id: "large-image-scale-" + (block.id || "default"),
        },
      },
    );
  }

  /**
   * Slow parallax: image is slightly oversized and drifts as it scrolls through view.
   */
  function initParallaxAnimation(block) {
    const media = block.querySelector(".large-image__media");
    if (!media || !canAnimate()) return;

    if (prefersReducedMotion()) {
      window.gsap.set(media, { yPercent: 0, scale: 1, transformOrigin: "50% 50%" });
      return;
    }

    window.gsap.set(media, { scale: 1.35, transformOrigin: "50% 50%" });

    window.gsap.fromTo(
      media,
      { yPercent: -16 },
      {
        yPercent: 16,
        ease: "none",
        scrollTrigger: {
          trigger: block,
          start: "top bottom",
          end: "bottom top",
          scrub: 0.8,
          invalidateOnRefresh: true,
          id: "large-image-parallax-" + (block.id || "default"),
        },
      },
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLargeImageEffects);
  } else {
    initLargeImageEffects();
  }
})();
